import React, { useState, useEffect } from "react";
import { data, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getOrDeleteRequest, postOrPutRequest, validateData, getSession, encryptData, customSwal } from "../../utils/utils";
import FormError from "../../components/FormError"
import SelectMultiple from "../../components/SelectMultiple";
import MainThemeLayout from "../../layout/MainThemeLayout";
import Input from "../../components/Input";
import InputFile from "../../components/inputFile";
import PrevButton from "../../components/PrevButton";
import { Link } from "react-router-dom";
import { faArrowLeft, faChevronDown, faChevronUp, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconSelector from "../../components/IconSelector/IconSelector";
import TextArea from "../../components/TextArea";
import { th } from "date-fns/locale";
import { format, set } from "date-fns";

function CompanyEditFormWithTerms() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [businessSectors, setBusinessSectors] = useState([]);
    const [companyId, setCompanyId] = useState(null);
    const [fileName, setFileName] = useState("");
    const [indicators, setIndicators] = useState([]);
    const [baselines, setBaselines] = useState([]);
    const [projects, setProjects] = useState([]);
    const { id } = useParams();
    const [editPassword, setEditPassword] = useState(!id ? true : false);
    const [baselineDates, setBaselineDates] = useState(null);
    const [dataProjects, setDataProjects] = useState([]);
    const [lineas, setLineas] = useState([]);

    const [formulario, setFormulario] = useState({
        company_name: '',
        address: '',
        state_id: '',
        city_id: '',
        district_id: '',
        trade_name: '',
        phone: '',
        business_sectors: '',
        nit: '',
        names: '',
        lastnames: '',
        about_us: '',
        image: '',
        contact_name: '',
        contact_phone: '',
        document_type: 'nit',
        dui: '',
        password: '',
        password_confirmation: '',
        email: '',
        latitude: '',
        longitude: '',
    });

    const [openProjectId, setOpenProjectId] = useState(null);

    const currentDate = new Date().toISOString().split('T')[0];

    const handleFile = (e) => {
        let file = e.target.files[0];
        if (file) {
            // console.log(file);
            setFileName(file.name);
            setFormulario({ ...formulario, image: file });
            // let reader = new FileReader();
            // reader.readAsDataURL(file);
            // reader.onloadend = () => {
            //     let base64 = reader.result;
            //     setFormulario({ ...formulario, logo: base64 });
            // };
            // if (id) {
            //     setFormularioEditar({ ...formularioEditar, logo: file });
            // } else {
            //     setFormulario({ ...formulario, logo: file });
            // }
        }
    };

    const [alert, setAlert] = useState([{
        inputName: "",
        status: false,
        message: ""
    }]);

    const [userInfo, setUserInfo] = useState({
        userName: "",
        role: "",
        company: "",
    })

    const getStates = async () => {
        let response = await getOrDeleteRequest(
            `states/filter`,
            'GET',
            null,
            false
        )

        if (response.type === 'success') {
            // console.log(response.data)
            setStates(response.data)

        }
    };

    const getCities = async (state) => {
        // console.log(state)
        let response = await getOrDeleteRequest(
            `cities/by-state/${state}`,
            'GET',
            null,
            true
        )
        // console.log(response);
        if (response.type === 'success') {
            // console.log(response.data);
            setCities(response.data);
        }
    }

    const getDistricts = async (city) => {
        let response = await getOrDeleteRequest(
            `districts/by-city/${city}`,
            'GET',
            null,
            true
        )

        if (response.type === 'success') {
            setDistricts(response.data)
        }
    }

    const getBusinessSectors = async () => {
        let response = await getOrDeleteRequest(
            `business_sectors/filter`,
            'GET',
            null,
            false
        )

        if (response.type === 'success') {
            // console.log(response.data)
            setBusinessSectors(response.data)

        }
    };

    const sendData = async () => {
        let companyData = { ...formulario };
        companyData.business_sectors = [formulario.business_sectors];

        if (typeof companyData.image !== 'object') {
            delete companyData.image;
        }

        // Limpiar campos según tipo de documento
        if (companyData.document_type === 'nit') {
            delete companyData.dui;
            delete companyData.other_document;
            delete companyData.name_other_document;
        } else if (companyData.document_type === 'dui') {
            delete companyData.nit;
            delete companyData.other_document;
            delete companyData.name_other_document;
        } else {
            delete companyData.nit;
            delete companyData.dui;
        }

        if (editPassword && id) {
            companyData.password = encryptData(companyData.password);
            companyData.password_confirmation = encryptData(companyData.password_confirmation);
        } else {
            delete companyData.password;
            delete companyData.password_confirmation;
        }

        try {
            // 1. Actualizar compañía
            const companyResponse = await postOrPutRequest(
                `company/update/${companyId}?_method=PUT`,
                'POST',
                { ...companyData, email: encryptData(companyData.email) }
            );

            if (companyResponse.type !== 'success') {
                throw new Error(companyResponse.message);
            }

            // // 2. Preparar datos de baselines para enviar (eliminando duplicados)
            // const baselinesToSend = baselines
            //     .filter(b => b.is_dirty && b.baseline !== '')
            //     .flatMap(baseline => {
            //         return baseline.all_term_ids.map(term_id => ({
            //             term_id,
            //             baseline: baseline.baseline,
            //             project_id: baseline.project_id,
            //             company_id: companyId,
            //             init_date: `${baselineDates ?? currentDate}`,
            //             id: baseline.term_baseline_map?.[term_id]?.id
            //         }));
            //     })
            //     // Eliminar duplicados conservando el último registro (más reciente)
            //     .reduce((unique, item) => {
            //         const existing = unique.find(
            //             u => u.term_id === item.term_id &&
            //                 u.project_id === item.project_id
            //         );

            //         if (!existing) {
            //             unique.push(item);
            //         } else {
            //             // Reemplazar el existente con el nuevo (último tendrá prioridad)
            //             const index = unique.indexOf(existing);
            //             unique[index] = item;
            //         }
            //         return unique;
            //     }, []);
            // // console.log('Baselines to send:', baselinesToSend);
            // // return;
            // // 3. Enviar todos los términos únicos
            // if (baselinesToSend.length > 0) {
            //     const baselinesResponse = await postOrPutRequest(
            //         `baseline-term/update/${companyId}`,
            //         'PUT',
            //         { baselines: baselinesToSend }
            //     );

            //     if (baselinesResponse.type !== 'success') {
            //         throw new Error(baselinesResponse.message);
            //     }
            // }

            // Éxito
            let baselinesSaved = true;
            baselinesSaved = await saveBaselines();
            console.log('Baselines saved:', baselinesSaved);

            if (baselinesSaved) {
                Swal.fire('Éxito', 'Datos guardados correctamente', 'success')
                    .then(() => {
                        // Reload the same page
                        navigate(0);
                    });
            } else {
                throw new Error('Error al guardar los valores de línea base');
                navigate(0);
            }

        } catch (error) {
            console.error('Save error:', error);
            Swal.fire('warning', error.message || 'Error al guardar los datos', 'warning');
        }
    };

    const saveBaselines = async () => {
        console.log("dataProjects to save:", dataProjects);
        const dataProcess = formatBaselineTerms(dataProjects, companyId);
        console.log('Data to save baselines:', dataProcess);
        const response = await postOrPutRequest('baseline-term/register', 'POST', { baselines: dataProcess });
        if (response.type === 'success') {
            console.log('response saving baselines:', response);
            return true;
        }
        console.error('Error saving baselines:', response);
        return false;
    }

    const formatBaselineTerms = (projects, companyId) => {
        console.log('Formatting baseline terms for projects:', projects);
        if (!Array.isArray(projects)) return [];

        return projects.flatMap(project => {
            if (!Array.isArray(project.baselines)) return [];

            return project.baselines.map(baseline => ({
                project_id: project.id,
                term_ids: (baseline.term_ids || []).map(term => {
                    if (typeof term === 'object' && term !== null) {
                        return {
                            term_id: term.term_id ?? term.id,
                            baseline_term_id: term.baseline_term_id ?? term.pivot?.id ?? 0
                        };
                    }
                    return {
                        term_id: term,
                        baseline_term_id: 0
                    };
                }),
                company_id: companyId,
                baseline_term_id: baseline.baseline_term_id || 0, // Ensure 0 if undefined/null
                baseline: baseline.value,
                target: baseline.target ?? null,
                description: baseline.description ?? null
            }));
        });
    };



    const validateDataForm = (e) => {
        e.preventDefault();

        let inputs = Object.entries(formulario).map(([key, value]) => {
            return {
                name: key,
                value: value,
            };
        });

        inputs = inputs.filter(input => input.name !== 'image');

        if (!(editPassword && id)) {
            inputs = inputs.filter(input => input.name !== 'password_confirmation' && input.name !== 'password');
        }

        if (formulario.document_type === 'nit') {
            inputs = inputs.filter(input => input.name !== 'dui' && input.name !== 'other_document' && input.name !== 'name_other_document');
        } else if (formulario.document_type === 'dui') {
            inputs = inputs.filter(input => input.name !== 'nit' && input.name !== 'other_document' && input.name !== 'name_other_document');
        } else {
            inputs = inputs.filter(input => input.name !== 'nit' && input.name !== 'dui');
        }

        if (![1, 6].includes(getSession().type_id) && !id) {
            inputs = inputs.filter(input => input.name !== 'projects');
        }

        const datosValidados = validateData(inputs);
        // console.log(datosValidados, "datos validados");
        setAlert(datosValidados);
        let totalValidaciones = datosValidados.filter((input) => input.status !== false).map(() => { return false });
        // console.log(totalValidaciones, "total validaciones");

        if (totalValidaciones.length === 0) {
            customSwal.fire({
                title: 'Cargando...',
                text: 'Por favor espere',
                allowOutsideClick: false,
                didOpen: () => {
                    customSwal.showLoading();
                }
            });
            sendData();
        }
    };

    const getData = async (id) => {
        let response = await getOrDeleteRequest(
            `company/find/${id}`,
            'GET',
        );
        // console.log(response, "response data company");
        if (response.type === 'success') {
            if (response.data) {
                console.log(response.data, "data company");
                getCities(response.data.state_id);
                getDistricts(response.data.city_id);

                let documentType = 'nit';
                if (response.data.dui) documentType = 'dui';
                if (response.data.other_document) documentType = 'other';

                // let nitData = decryptData(response.data.nit);

                setFormulario({
                    company_name: response.data.company_name,
                    address: response.data.address,
                    state_id: response.data.state_id,
                    city_id: response.data.city_id,
                    district_id: response.data.district_id,
                    trade_name: response.data.trade_name,
                    phone: response.data.phone,
                    business_sectors: response.data.business_sectors[0].id,
                    document_type: documentType,
                    nit: response.data.nit || '',
                    dui: response.data.dui || '',
                    other_document: response.data.other_document || '',
                    name_other_document: response.data.name_other_document || '',
                    names: response.data.names,
                    lastnames: response.data.lastnames,
                    about_us: response.data.about_us,
                    image: response.data.image,
                    contact_name: response.data.contact_name,
                    contact_phone: response.data.contact_phone,
                    projects: response.data.projects.length > 0 ? response.data.projects.map((project) => project.id) : [],
                    password: '',
                    password_confirmation: '',
                    email: response.data.email || '',
                    latitude: response.data.latitude || '',
                    longitude: response.data.longitude || '',
                });

                setFileName(response.data.image || '');

                console.log(response.data, "projects de la company");

                const indicatorsData = await getIndicatorsByProjects(response.data.projects.map((project) => project.id), id);
                await getBaselines(response.data.projects || [], response.data.id, indicatorsData);
            } else {
                Swal.fire({
                    title: '¡Error!',
                    text: 'No se encontraron datos sobre este tipo de indicador',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                }).then(() => {
                    navigate('/TiposDeIndicadores');
                });
            }
        } else {
            Swal.fire({
                title: '¡Error!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const loadData = () => {
        let sesion = getSession();

        let userRole = "No especificado"

        if (sesion.type_id === 1) {
            userRole = "Administrador"
        }

        if (sesion.type_id === 4) {
            userRole = "Organización"
        }

        setUserInfo({
            userName: sesion.type_id === 4 ? sesion?.company.company_name : sesion.username,
            role: userRole,
            company: sesion.type_id === 4 ? sesion.company_name : "No aplica"
        })

        let companyInfo = sesion?.company;
        // console.log(companyInfo, "companyInfo");
        setCompanyId(id ?? companyInfo.id)
        getData(id ?? companyInfo.id)
    };

    const handleChange = (e) => {
        let newForm = { ...formulario }; // Copiar el formulario
        // e.target.name -> Obtener el nombre del input
        newForm[e.target.name] = e.target.value; // Asignar el nuevo valor
        // console.log(newForm);
        setFormulario(newForm); // Remmplazas todo por el nuevo form (copia)
    };

    const allFunctions = async () => {
        setLoading(true);
        await getStates();
        await getBusinessSectors();

        loadData();

        // if (sessionStorage.getItem('infoOrg')) {
        //     let info = JSON.parse(sessionStorage.getItem('infoOrg'));
        //     getCities(info.state_id);
        //     getDistricts(info.city_id);
        //     setFormulario(info);
        // }

        setLoading(false);
    }

    const getIndicatorsByProjects = async (projectIds, companyId) => {
        try {
            const projectsResponse = await getOrDeleteRequest('projects/filter', 'GET');
            if (projectsResponse.type !== 'success') throw new Error(projectsResponse.message);

            const allProjects = Array.isArray(projectsResponse.data) ? projectsResponse.data : [];
            setProjects(allProjects);

            const processedProjects = await Promise.all(
                projectIds.map(async (projectId) => {
                    const project = allProjects.find(p => p.id === projectId);
                    if (!project?.forms?.length) return { projectId, indicatorGroups: [] };

                    const indicatorsResponse = await getOrDeleteRequest(
                        `forms/form-indicator-terms/${project.forms[0].id}`,
                        'GET'
                    );

                    const indicatorData = Array.isArray(indicatorsResponse.data) ? indicatorsResponse.data : [];

                    if (indicatorsResponse.type === 'success') {
                        const indicatorGroups = indicatorData.reduce((groups, indicator) => {
                            if (!indicator?.idicator_id) return groups;

                            const groupKey = indicator.idicator_id;

                            if (!groups[groupKey]) {
                                groups[groupKey] = {
                                    indicator_id: indicator.idicator_id,
                                    name: indicator.term_name || 'Sin nombre',
                                    all_term_ids: [indicator.idicator_id],
                                    project_id: projectId,
                                    icon: indicator.icon,
                                    description: indicator.description || ''
                                };
                            }

                            if (Array.isArray(indicator.term_ids)) {
                                groups[groupKey].all_term_ids = [
                                    ...groups[groupKey].all_term_ids,
                                    ...indicator.term_ids
                                ];
                            }

                            return groups;
                        }, {});

                        return {
                            projectId,
                            indicatorGroups: Object.values(indicatorGroups)
                        };
                    }
                    return { projectId, indicatorGroups: [] };
                })
            );

            const initialBaselines = processedProjects
                .filter(project => Array.isArray(project.indicatorGroups))
                .flatMap(project =>
                    project.indicatorGroups.map(group => ({
                        indicator_id: group.indicator_id,
                        project_id: project.projectId,
                        company_id: companyId,
                        baseline: '',
                        all_term_ids: [...new Set(group.all_term_ids)],
                        is_dirty: false
                    }))
                );

            // get the baseline date

            setIndicators(processedProjects.filter(project => Array.isArray(project.indicatorGroups)));
            setBaselines(initialBaselines);

            await loadExistingBaselines(companyId, projectIds);

            return processedProjects;

        } catch (error) {
            console.error('Error loading indicators:', error);
            Swal.fire('Error', 'No se pudieron cargar los indicadores', 'error');
            return [];
        }
    };

    const handleBaselineChange = (indicatorId, projectId, value) => {
        setBaselines(prev =>
            prev.map(baseline => {
                if (baseline.indicator_id === indicatorId && baseline.project_id === projectId) {
                    // console.log(baseline, "baseline antes de actualizar");
                    return {
                        ...baseline,
                        baseline: value,
                        is_dirty: true
                    };
                }
                return baseline;
            })
        );
    };

    const loadExistingBaselines = async (companyId, projectIds) => {
        try {
            const response = await postOrPutRequest(
                'baseline-term/by-project-company',
                'POST',
                { project_ids: projectIds, company_id: companyId }
            );

            if (response.type === 'success' && response.data?.length > 0) {
                setBaselines(prev => {
                    return prev.map(indicatorGroup => {
                        if (!indicatorGroup.all_term_ids?.length) {
                            return indicatorGroup;
                        }

                        const relevantBaselines = response.data.filter(b =>
                            b.project_id === indicatorGroup.project_id &&
                            indicatorGroup.all_term_ids.includes(b.term_id)
                        );

                        if (relevantBaselines.length === 0) {
                            return indicatorGroup;
                        }

                        const termBaselineMap = {};
                        relevantBaselines.forEach(b => {
                            termBaselineMap[b.term_id] = {
                                baseline: b.baseline,
                                id: b.id,
                                updated_at: b.updated_at
                            };
                        });

                        let groupBaseline = '';
                        let groupBaselineSource = null;

                        const mainTermBaseline = termBaselineMap[indicatorGroup.indicator_id];
                        if (mainTermBaseline?.baseline) {
                            groupBaseline = mainTermBaseline.baseline;
                            groupBaselineSource = mainTermBaseline;
                        }

                        if (!groupBaseline) {
                            for (const term_id of indicatorGroup.all_term_ids) {
                                const termBaseline = termBaselineMap[term_id];
                                if (termBaseline?.baseline) {
                                    groupBaseline = termBaseline.baseline;
                                    groupBaselineSource = termBaseline;
                                    break;
                                }
                            }
                        }

                        if (!groupBaseline && relevantBaselines.some(b => b.updated_at)) {
                            const mostRecent = relevantBaselines.reduce((a, b) =>
                                new Date(a.updated_at) > new Date(b.updated_at) ? a : b
                            );
                            groupBaseline = mostRecent.baseline;
                            groupBaselineSource = mostRecent;
                        }

                        return {
                            ...indicatorGroup,
                            baseline: groupBaseline,
                            term_baseline_map: termBaselineMap,
                            baseline_source: groupBaselineSource
                                ? {
                                    term_id: groupBaselineSource.term_id,
                                    updated_at: groupBaselineSource.updated_at
                                }
                                : null
                        };
                    });
                });
            }
        } catch (error) {
            console.error('Error loading existing baselines:', error);
            Swal.fire({
                title: 'Error',
                text: 'No se pudieron cargar los valores históricos',
                icon: 'error'
            });
        }
    };

    const getBaselines = async (projects, companyId, indicatorsData = []) => {
        try {
            const projectBaselines = await Promise.all(projects.map(async (project) => {
                let response = await getOrDeleteRequest(`projects/baselines/${project.id}?company_id=${companyId}`, 'GET');
                console.log(response, "response baselines");

                if (response.type === 'success') {
                    const baselines = response.data.map((group) =>
                        group.baselines.map((baseline) => {
                            // Find fallback terms from indicatorsData
                            const projectIndicators = indicatorsData.find(p => p.projectId === project.id);
                            const groupIndicators = projectIndicators?.indicatorGroups.find(g => g.indicator_id === group.id);
                            const fallbackTerms = groupIndicators?.all_term_ids || [];

                            return {
                                id: baseline.id,
                                name: baseline.name,
                                unit: baseline.unit_of_measurement,
                                value: baseline.value,
                                baseline_term_id: baseline.baseline_term_id,
                                term_ids: baseline.terms || baseline.term_ids || group.terms || group.term_ids || fallbackTerms || [],
                            };
                        })
                    ).flat(); // Solo un flat() para aplanar el array de arrays de baselines

                    return {
                        id: project.id,
                        name: project.name,
                        baselines: baselines
                    };
                }
                return null;
            }));

            console.log(projectBaselines, "projectBaselines");

            setDataProjects(projectBaselines.filter(p => p !== null));
        } catch (error) {
            console.error('Error fetching baselines:', error);
        }
    }

    const handleBaselines = (projectId, baselineId, newValue) => {
        setDataProjects(prevProjects =>
            prevProjects.map(project => {
                if (project.id === projectId) {
                    return {
                        ...project,
                        baselines: project.baselines.map(baseline =>
                            baseline.id === baselineId
                                ? { ...baseline, value: newValue }
                                : baseline
                        )
                    };
                }
                return project;
            })
        );
    };

    const toggleAccordionBaselines = (projectId) => {
        setOpenProjectId(openProjectId === projectId ? null : projectId);
    };



    useEffect(() => {
        allFunctions();
    }, []);

    useEffect(() => { console.log(lineas) }, [lineas]);
    useEffect(() => { console.log(dataProjects) }, [dataProjects]);
    useEffect(() => { console.log(formulario) }, [formulario]);

    const [expandedProjects, setExpandedProjects] = useState({});

    const toggleAccordion = (projectId) => {
        setExpandedProjects(prev => ({
            ...prev,
            [projectId]: !prev[projectId]
        }));
    };

    useEffect(() => {
        if (indicators.length > 0) {
            const initialExpanded = {};
            indicators.forEach(project => {
                initialExpanded[project.projectId] = false;
            });
            setExpandedProjects(initialExpanded);
        }
    }, [indicators]);

    useEffect(() => {
        console.log('Baselines updated:', baselines);
    }, [baselines]);

    return (
        <MainThemeLayout>
            <form onSubmit={validateDataForm} className="flex flex-col w-full">
                {/* Header y botón de regreso */}
                <div className="p-4">
                    <div className="cursor-pointer" onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={faArrowLeft} className={`text-turquesa text-xl`} />
                    </div>
                    <h1 className="bg-white dark:bg-[#292929] dark:text-white px-4 py-10 text-center text-2xl font-semibold rounded-lg text-turquesa mt-10">
                        Actualizar datos de la organización
                    </h1>
                </div>

                <div className="w-full px-4">
                    <div className="flex flex-wrap w-full bg-white dark:bg-[#292929] rounded-lg py-4 px-2">
                        {/* Primera fila - Información básica */}
                        <div className="w-full md:w-1/2 px-2 mb-4">
                            <Input
                                type="text"
                                label="Nombre de la organización"
                                name="company_name"
                                required={true}
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.company_name}
                                placeholder="Ingrese el nombre"
                            />
                        </div>

                        <div className="w-full md:w-1/2 px-2 mb-4">
                            <Input
                                type="text"
                                label="Dirección"
                                name="address"
                                required={true}
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.address}
                                placeholder="Ingrese la dirección"
                            />
                        </div>

                        {/* Segunda fila - Ubicación */}
                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <SelectMultiple
                                name="state_id"
                                loading={loading}
                                array={states}
                                isMulti={false}
                                label="Departamento"
                                required={true}
                                alert={alert}
                                value={formulario.state_id}
                                onChange={(e) => {
                                    getCities(e);
                                    handleChange({ target: { name: 'state_id', value: e } });
                                }}
                                placeholder="Seleccione departamento"
                            />
                        </div>

                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <SelectMultiple
                                name="city_id"
                                label="Municipio"
                                loading={loading}
                                array={cities}
                                isMulti={false}
                                required={true}
                                alert={alert}
                                value={formulario.city_id}
                                onChange={(e) => {
                                    getDistricts(e);
                                    handleChange({ target: { name: 'city_id', value: e } });
                                }}
                                placeholder="Seleccione municipio"
                            />
                        </div>

                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <SelectMultiple
                                name="district_id"
                                label="Distrito"
                                loading={loading}
                                array={districts}
                                isMulti={false}
                                alert={alert}
                                value={formulario.district_id}
                                onChange={(e) => handleChange({ target: { name: 'district_id', value: e } })}
                                placeholder="Seleccione distrito"
                            />
                        </div>

                        {/* Tercera fila - Documentos */}
                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <SelectMultiple
                                name="document_type"
                                label="Tipo de Documento"
                                loading={loading}
                                array={[
                                    { id: 'nit', name: 'NIT' },
                                    { id: 'dui', name: 'DUI' },
                                    { id: 'other', name: 'Otro Documento' }
                                ]}
                                isMulti={false}
                                required={true}
                                alert={alert}
                                value={formulario.document_type}
                                onChange={(e) => handleChange({ target: { name: 'document_type', value: e } })}
                                placeholder="Seleccione tipo"
                            />
                        </div>

                        {formulario.document_type === 'nit' && (
                            <div className="w-full md:w-1/3 px-2 mb-4">
                                <Input
                                    type="text"
                                    label="NIT"
                                    name="nit"
                                    required={true}
                                    alert={alert}
                                    mask="9999-999999-999-9"
                                    onChange={handleChange}
                                    value={formulario.nit}
                                    placeholder="0000-000000-000-0"
                                />
                            </div>
                        )}

                        {formulario.document_type === 'dui' && (
                            <div className="w-full md:w-1/3 px-2 mb-4">
                                <Input
                                    type="text"
                                    label="DUI"
                                    name="dui"
                                    required={true}
                                    alert={alert}
                                    mask="99999999-9"
                                    onChange={handleChange}
                                    value={formulario.dui}
                                    placeholder="00000000-0"
                                />
                            </div>
                        )}

                        {formulario.document_type === 'other' && (
                            <>
                                <div className="w-full md:w-1/3 px-2 mb-4">
                                    <Input
                                        type="text"
                                        label="Nombre del Documento"
                                        name="name_other_document"
                                        required={true}
                                        alert={alert}
                                        onChange={handleChange}
                                        value={formulario.name_other_document}
                                        placeholder="Ej: Pasaporte"
                                    />
                                </div>
                                <div className="w-full md:w-1/3 px-2 mb-4">
                                    <Input
                                        type="text"
                                        label="Número de Documento"
                                        name="other_document"
                                        required={true}
                                        alert={alert}
                                        onChange={handleChange}
                                        value={formulario.other_document}
                                        placeholder="Número completo"
                                    />
                                </div>
                            </>
                        )}

                        <div className="w-full md:w-1/2 px-2 mb-4">
                            <Input
                                type="text"
                                label="Latitud"
                                name="latitude"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.latitude}
                                placeholder="Ej: 13.6929"
                            />
                        </div>
                        <div className="w-full md:w-1/2 px-2 mb-4">
                            <Input
                                type="text"
                                label="Longitud"
                                name="longitude"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.longitude}
                                placeholder="Ej: -89.2182"
                            />
                        </div>

                        {/* Cuarta fila - Información adicional */}
                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <Input
                                type="text"
                                label="Razón social"
                                name="trade_name"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.trade_name}
                            />
                        </div>

                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <div className="mb-1 block font-medium text-sm text-slate-700 dark:text-white">
                                Imagen de la organización
                            </div>
                            <InputFile
                                name='image'
                                loading={loading}
                                fileName={fileName}
                                onChange={handleFile}
                            />
                            <FormError errors={alert} name={"image"} />
                        </div>

                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <SelectMultiple
                                name="business_sectors"
                                label="Sector de negocio"
                                loading={loading}
                                array={businessSectors}
                                isMulti={false}
                                required={true}
                                alert={alert}
                                value={formulario.business_sectors}
                                onChange={(e) => handleChange({ target: { name: 'business_sectors', value: e } })}
                                placeholder="Seleccione sector"
                            />
                        </div>

                        {[1, 6].includes(getSession().type_id) && id &&
                            <div className="w-full md:w-1/3 px-2 mb-4">
                                <SelectMultiple
                                    name="projects"
                                    label="Proyectos"
                                    loading={loading}
                                    array={projects}
                                    isMulti={true}
                                    required={true}
                                    alert={alert}
                                    value={formulario.projects}
                                    onChange={(e) => handleChange({ target: { name: 'projects', value: e } })}
                                    placeholder="Seleccione los proyectos"
                                />
                            </div>
                        }

                        {/* Quinta fila - Contacto */}
                        <div className="w-full md:w-1/2 px-2 mb-4">
                            <Input
                                type="text"
                                label="Persona de contacto"
                                name="contact_name"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.contact_name}
                            />
                        </div>

                        <div className="w-full md:w-1/2 px-2 mb-4">
                            <Input
                                type="text"
                                label="Teléfono de contacto"
                                name="contact_phone"
                                alert={alert}
                                mask="9999-9999"
                                prefix="+503 "
                                onChange={handleChange}
                                value={formulario.contact_phone}
                                placeholder="0000-0000"
                            />
                        </div>
                        
                        {[1, 6].includes(getSession().type_id) && id &&
                            <div className="w-full md:w-1/2 px-2 mb-4">
                                <Input
                                    type="email"
                                    label="Correo electrónico"
                                    name="email"
                                    alert={alert}
                                    onChange={handleChange}
                                    value={formulario.email}
                                    placeholder="ejemplo@correo.com"
                                />
                            </div>
                        }

                        {/* Sexta fila - Sobre la organización */}
                        <div className="w-full px-2 mb-4">
                            <TextArea
                                type="text"
                                label="Cuéntanos sobre la organización"
                                name="about_us"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.about_us}
                                rows={4}
                            />
                        </div>

                        {/* Séptima fila - Representante */}
                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <Input
                                type="text"
                                label="Nombres del representante"
                                name="names"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.names}
                            />
                        </div>

                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <Input
                                type="text"
                                label="Apellidos del representante"
                                name="lastnames"
                                alert={alert}
                                onChange={handleChange}
                                value={formulario.lastnames}
                            />
                        </div>

                        <div className="w-full md:w-1/3 px-2 mb-4">
                            <Input
                                type="text"
                                label="Teléfono del representante"
                                name="phone"
                                alert={alert}
                                mask="9999-9999"
                                prefix="+503 "
                                onChange={handleChange}
                                value={formulario.phone}
                                placeholder="0000-0000"
                            />
                        </div>

                        <div className="w-full flex flex-wrap px-2 mb-4">
                            {id && <div className="w-full">
                                <div className="flex items-center justify-between mb-2">
                                    <label className="text-sm text-stone-700 dark:text-white">
                                        {editPassword ? "Contraseña de la organización" : "Editar contraseña de la organización"}
                                    </label>
                                    <button
                                        type="button"
                                        className="text-xs text-blue-500 hover:underline"
                                        onClick={() => setEditPassword(!editPassword)}
                                    >
                                        {editPassword ? "Cancelar edición" : "Editar contraseña"}
                                    </button>
                                </div>
                                <p className="text-xs text-stone-500 dark:text-white mb-2">
                                    {editPassword ? "Ingrese la contraseña de la organización." : "Si desea editar la contraseña, haga clic en 'Editar contraseña'."}
                                </p>
                            </div>}

                            {(editPassword && id) && (
                                <>
                                    <div className="w-full md:w-1/2 px-2 pb-4">
                                        <Input
                                            type="password"
                                            label="Contraseña de la organización"
                                            name="password"
                                            loading={loading}
                                            alert={alert}
                                            required
                                            onChange={handleChange}
                                            value={formulario.password || ''}
                                            placeholder="Ingrese la contraseña"
                                            tooltip="Contraseña de la organización"
                                        />
                                    </div>
                                    <div className="w-full md:w-1/2 px-2 pb-4">
                                        <Input
                                            type="password"
                                            label="Confirmar contraseña de la organización"
                                            name="password_confirmation"
                                            loading={loading}
                                            alert={alert}
                                            required
                                            onChange={handleChange}
                                            value={formulario.password_confirmation || ''}
                                            placeholder="Confirme la contraseña"
                                            tooltip="Confirmar contraseña de la organización"
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {[1, 6].includes(getSession().type_id) && id && (
                            <>
                                <div className="p-2">
                                    <h1 className="w-full text-xl text-center font-semibold text-stone-700 dark:text-white mb-4 mt-2 flex items-center gap-2">
                                        Líneas Base
                                    </h1>

                                    <h3 className="w-full text-sm text-justify text-gray-600 dark:text-gray-300 mb-6 flex items-center gap-2">
                                        Establezca las líneas base datos específicos a los proyectos seleccionados. Estos valores iniciales son cruciales para medir el progreso y el impacto de la organización en relación con sus objetivos.
                                    </h3>
                                </div>

                                <div className="w-full mx-auto p-2">
                                    {
                                        dataProjects.length > 0 &&
                                        dataProjects.map((project, key) => {

                                            // 🚨 Define 'isOpen' aquí, asumiendo que 'project' tiene un 'id' único.
                                            const isOpen = project.id === openProjectId;

                                            return (
                                                // 1. Contenedor Principal: Usa 'border', 'rounded-lg' y 'shadow-sm'
                                                <div
                                                    key={key}
                                                    className="border border-gray-200 rounded-lg mb-4 shadow-sm"
                                                >

                                                    {/* 2. Encabezado del Acordeón (Nombre del proyecto) */}
                                                    <div
                                                        // 🚨 Agrega onClick para activar el acordeón
                                                        onClick={() => toggleAccordionBaselines(project.id)}
                                                        className={`
                        flex justify-between items-center p-4 cursor-pointer 
                        text-lg font-semibold transition duration-300
                        ${isOpen // Estilo condicional para el estado abierto
                                                                ? 'bg-yellow-50 text-yellow-800 border-b border-gray-200'
                                                                : 'bg-[#007A99] hover:bg-gray-50 text-zinc-100 hover:text-gray-900'
                                                            }
                    `}
                                                    >
                                                        {project.name}

                                                        {/* 🔽 Icono Rotatorio */}
                                                        <svg
                                                            className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                        >
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    </div>

                                                    {/* 3. Cuerpo del Acordeón (Contenido) */}
                                                    {/* 🚨 Renderiza condicionalmente si 'isOpen' es verdadero */}
                                                    {isOpen && (
                                                        <div className="p-4 bg-white">

                                                            {/* Grid de 3 tarjetas */}
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                                                {/* Ajuste: Aumenté el 'gap' de 2 a 4 para mejor separación de tarjetas */}

                                                                {project.baselines.length > 0
                                                                    ?
                                                                    project.baselines.map((baseline, index) => (
                                                                        <div
                                                                            key={baseline.id}
                                                                            // Estilo de tarjeta refinado
                                                                            className="bg-white shadow-md rounded-lg p-4 border border-gray-100 hover:shadow-lg transition"
                                                                        >
                                                                            <div className="text-gray-800 text-sm mb-2 h-14 overflow-hidden font-medium">
                                                                                {baseline.name}
                                                                            </div>
                                                                            <input
                                                                                id={`baseline-${project.id}-${baseline.id}`}
                                                                                type="number"
                                                                                className="border rounded-lg p-2 w-full focus:ring focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                                                                                value={baseline.value}
                                                                                onChange={(e) => handleBaselines(project.id, baseline.id, e.target.value)}
                                                                                placeholder="Ingresar valor"
                                                                            />
                                                                            <div className="text-xs text-gray-500 mt-1">
                                                                                {baseline.unit.unit}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                    : <div className="text-gray-500">No hay líneas base disponibles para este proyecto.</div>
                                                                }
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Botones de acción */}
                <div className="px-4 mb-5 flex flex-col sm:flex-row justify-center gap-2">
                    <button
                        type="button"
                        className="mt-4 text-sm rounded-lg bg-turquesa p-3 font-medium text-white hover:bg-opacity-90"
                        onClick={validateDataForm}
                    >
                        Actualizar
                    </button>
                    <Link
                        to={"/PerfilDeLaOrganizacion"}
                        className="mt-4 text-sm rounded-lg bg-red-500 p-3 font-medium text-white hover:bg-opacity-90 text-center"
                    >
                        Cancelar
                    </Link>
                </div>
            </form>
        </MainThemeLayout>
    );

}

export default CompanyEditFormWithTerms;